import type { Locale } from '@/lib/i18n/config'

function hasFractionalCents(value: number): boolean {
  return !value.toFixed(2).endsWith('.00')
}

function getPriceNumberFormatter(locale: Locale, hasCents: boolean): Intl.NumberFormat {
  return new Intl.NumberFormat(locale === 'de' ? 'de-DE' : 'en-GB', {
    maximumFractionDigits: hasCents ? 2 : 0,
    minimumFractionDigits: hasCents ? 2 : 0,
  })
}

/** Formats price numbers with locale-appropriate thousands and decimal separators. */
export function formatPriceNumber(value: number, locale: Locale): string {
  const hasCents = hasFractionalCents(value)
  return getPriceNumberFormatter(locale, hasCents).format(value)
}
